<template>
  <div>
    <h2>Образцы документов</h2>
    <div v-if="error" class="error">
      {{ error.message || JSON.stringify(error, null, 2) }}
    </div>

    <form v-else class="contract-form" @submit.prevent="saveSamples">
      <div v-for="contract in this.contracts">
        <p>{{contract.title}}</p>
        <div class="upload-contract-button-container">
          <input
            type="file"
            v-bind:id="`${contract.name}`"
            v-bind:name="`${contract.name}`"
            class="button"
          />
          <a class="uploaded-contract-link" target="_blank" v-bind:href="`${contract.filePath}?p=${generateRandomPostfix()}`">
            {{contract.filePath}}
          </a>
        </div>
      </div>

      <button class="button">Сохранить</button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Contracts',
  mounted() {
    this.getContracts()
  },
  data() {
    return {
      contracts: [],
      error: null
    }
  },
  props: {},
  methods: {
    generateRandomPostfix() {
      return Math.floor(Math.random() * 1000)
    },
    async getContracts() {
      const { data } = await this.axios.get('/uprid/contracts')

      this.contracts = data
    },
    async saveSamples(e) {
      const formData = new FormData(e.target)
      try {
        const { data: updatedData } = await this.axios.put('/uprid/contracts', formData)
        this.$toast.open({ message: 'Сохранено' })
        e.target.reset()

        const newContracts = []

        for (const contract of this.contracts) {
          const updatedContracts = updatedData.contracts.filter(c => c.name === contract.name)

          if (updatedContracts && updatedContracts.length > 0) {
            newContracts.push({  ...contract, ...updatedContracts[0]})
          }
          else {
            newContracts.push(contract)
          }
        }

        this.contracts = newContracts
      } catch (e) {
        this.$toast.open({ message: 'Ошибка' })
        this.error = e
      }
    }
  }
}
</script>

<style>
.contract-form div {
  flex-wrap: wrap;
}
.contract-form div + div {
  margin-top: 1.5rem;
}
.contract-form div label {
  width: 320px;
}
.contract-form button {
  margin-top: 1.5rem;
}
.uploaded-contract-link {
  margin-left: 15px;
}
.upload-contract-button {
  border: 1px black solid;
  padding: 10px 20px;
}
.upload-contract-button-container {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// Contracts.vue?5d5db64e